let url = new URL(window.location.href)
let paths = url.pathname.slice(1).split('/').filter(l => l.length)

let hasFilterTag = paths.length == 3

console.log(paths, url.pathname, hasFilterTag)

if (hasFilterTag) {
  const currentFilterTag = paths.at(-1).toLowerCase().replace(/[^a-z]/g, '')
  console.log('Current filter tag: ', currentFilterTag)

  const withoutFilterTag = '/' + [...paths].slice(0, -1).join('/')
  console.log('withoutFilterTag', withoutFilterTag)
  
  Array.from(document.querySelectorAll('.filter_tag')).forEach(filter_tag_el => {
    console.log(filter_tag_el)
    const filter_tag_text = filter_tag_el?.textContent?.toLowerCase?.()?.trim?.()?.replace(/[^a-z]/g, '')
    const is_active_filter_tag = currentFilterTag == filter_tag_text
    console.log('filter_tag_text: ', filter_tag_text, ' is_active_filter_tag: ', is_active_filter_tag)
    
    if (!is_active_filter_tag) {
      // filter_tag_el.classList.remove('active')
      return
    } 

    filter_tag_el.classList.add('active')
    filter_tag_el.parentElement.setAttribute('href', withoutFilterTag)
  })
}

const products = document.querySelector('#ProductCountDesktop')
products.textContent = products.textContent.trim().split(/\s+/).slice(0, -1).join(' ')